<template>
    <div id="inner-auth-content" class="d-flex flex-column align-center justify-left" style="width: 350px">
        <!--<button id="installApp">Install</button>-->
        <v-btn id="install" class="mt-0 myprovet-btn-ok" v-if="!showUpdateMpv" > {{ $t('auth.installApp') }}</v-btn>
        <div class="d-flex justify-center align-center msg-updating" v-if="showUpdateMpv">
            <p>
                <b>{{ $t('auth.update.title') }}</b><br/>
                <br/>
                {{ $t('auth.update.text1') }}
                {{ $t('auth.update.text2') }}
                <br/>
                <br/>
                {{ $t('auth.update.text3') }}
                <br/>
                <br/>
                <a href="https://youtu.be/Uomi_ffmL5Q" class="link-no-decor" target="_blank"> {{ $t('auth.update.watch') }} </a>
            </p>
        </div>
        <v-form class="mt-9" style="width: 300px" ref="form" lazy-validation v-if="!showUpdateMpv">
            <div class="d-flex justify-center align-center">
                <v-text-field v-model="form.email" :rules="[rules.required, rules.email]" type="email" label="Email" autocomplete="email" width="300" autofocus required dense class="mb-3 left-input" :class="{ 'autofill-fix': autofillFix }" @keyup.enter="submitForm" data-cy="email"> </v-text-field>
            </div>
            <div class="d-flex justify-start align-center">
                <p v-if="form.errors && form.errors.email && form.errors.email.length" data-cy="email-error" class="red--text subtitle-2 mb-3">
                    {{ tServer(form.errors.email[0]) }}
                </p>
            </div>
            <div class="d-flex justify-center align-center">
                <v-text-field
                    style="height: 52px"
                    v-model="form.password"
                    :rules="[rules.required, rules.validLength]"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showPassword = !showPassword"
                    @keyup.enter="submitForm"
                    :label="$t('auth.password')"
                    autocomplete="current-password"
                    required
                    dense
                    class="mb-3 left-input"
                    :class="{ 'autofill-fix': autofillFix }"
                    data-cy="password"
                    @focus="autofillFix = false"
                ></v-text-field>
            </div>

            <div class="d-flex justify-start align-center">
                <p v-if="form.errors && form.errors.password && form.errors.password.length" class="red--text subtitle-2 mb-0" data-cy="password-error">
                    {{ tServer(form.errors.password[0]) }}
                </p>
            </div>

            <div class="d-flex justify-start align-center" style="margin-top: -10px; height: 32px">
                <p v-if="form.errors && form.errors.message && form.errors.message.length" v-html="tServer(form.errors.message[0])" class="error--text" style="line-height: 16px; font-size: 12px" data-cy="errors"></p>
            </div>

            <div class="d-flex justify-center">
                <v-btn @click="submitForm" :loading="loading" class="mt-0 myprovet-btn-ok" data-cy="submit-button"> {{ $t('auth.login') }} </v-btn>
            </div>

            <div v-if="showAutomaticLoginButtons()" class="d-flex justify-center align-center mt-8">
                <inertia-link class="no-underline text-center myprovet-btn-ok mr-1" href="/login/user"> Login (Cliente) </inertia-link>
                <inertia-link class="no-underline text-center myprovet-btn-ok ml-1" href="/login/admin-dashboard"> Login (Admin) </inertia-link>
                <inertia-link class="no-underline text-center myprovet-btn-ok ml-1" href="/login/admin"> Login (Back) </inertia-link>
            </div>
        </v-form>
        <div class="responsive-auth-login-link" v-if="showForgetPassword">
            <span class="d-flex justify-left responsive-auth-font" style="color: darkgrey">
                {{ $t('auth.forgotPrefix') }}

                <inertia-link class="no-underline" href="/forgot-password" data-cy="forgot-password-link"> &nbsp;{{ $t('auth.clickHere') }} </inertia-link>
            </span>

            <span class="d-flex mt-1 justify-left responsive-auth-font" style="color: darkgrey">
                {{ $t('auth.newHere') }}

                <inertia-link class="no-underline" href="/register"> &nbsp;{{ $t('auth.registerHere') }} </inertia-link>
            </span>
        </div>

        <social-media-auth> </social-media-auth>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { axios } from '@/Services/Backend';
import AuthLayout from '../Layouts/AuthLayout';
import { i18n } from '@/i18n';

// Decided at runtime from the hostname. `process.env.APP_ENV` is not available in the browser bundle (Mix only exposes MIX_* variables), so it can't be used here.
//   localhost / *.test / *.local  -> showPassword: true,  showUpdateMpv: false, showForgetPassword: true
//   prod.myprovet.pt              -> showPassword: false, showUpdateMpv: true,  showForgetPassword: false
//   myprovet.pt (and any other)   -> showPassword: false, showUpdateMpv: false, showForgetPassword: true
const hostname = window.location.hostname;
const isLocalEnvironment = ['localhost', '127.0.0.1'].includes(hostname) || hostname.endsWith('.test') || hostname.endsWith('.local');
const isProdEnvironment = hostname === 'prod.myprovet.pt';



export default {
    data() {
        return {
            form: {
                email: '',
                password: '',
                errors: null,
            },
            rules: {
                required: (value) => (value && !!value) || i18n.t('validation.required'),
                validLength: (value) => (value && value.length >= 8) || i18n.t('userDetails.rules.minLength'),
                email: function (value) {
                    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return value && re.test(value) ? true : i18n.t('userDetails.rules.invalidEmail');
                },
            },
            showPassword: isLocalEnvironment,
            loading: false,
            autofillFix: false,
            showUpdateMpv: isProdEnvironment,
            showForgetPassword: !isProdEnvironment
        };
    },

    created() {},

    computed: {
        ...mapStores(useUserStore),
    },

    mounted() {
        this.autoLoginCheckingInterface();
        //let deferredPrompt;
        if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
            const install_button = document.querySelector('#install');
            install_button.style.display = 'none';
        }else{
            if(navigator.userAgent.search("Chrome")){
                this.installApp();
            }
        }
    },

    methods: {

        installApp(){
            window.deferredPrompt = {};

            // get button with id
            const install_button = document.querySelector('#install');

            // if the app can be installed emit beforeinstallprompt
            window.addEventListener('beforeinstallprompt', e => {
            // this event does not fire if the application is already installed
            // then your button still hidden ;)

            // show button with display:block;
            install_button.style.display = 'block';

            // prevent default event
            e.preventDefault();

            // store install avaliable event
            window.deferredPrompt = e;

                // wait for click install button by user
            install_button.addEventListener('click', e => {
                    window.deferredPrompt.prompt();
                    window.deferredPrompt.userChoice.then(choiceResult => {
                    if (choiceResult.outcome === 'accepted') {
                        // user accept the prompt
                        // lets hidden button
                        install_button.style.display = 'none';
                    } else {
                        console.log('User dismissed the prompt');
                    }
                    window.deferredPrompt = null;
                    });
                });
            });

            // if are standalone android OR safari
            if (window.matchMedia('(display-mode: fullscreen)').matches || window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
            //if(this.getPWADisplayMode()){
                // hidden the button
                install_button.style.display = 'none';
            }
            //console.log('teste',this.getPWADisplayMode());
            // do action when finished install
            window.addEventListener('appinstalled', e => {
                console.log("success app install!");
                //install_button.style.display = 'none';
            });
        },
        getPWADisplayMode() {
            if (document.referrer.startsWith('android-app://'))
                return 'twa';
            if (window.matchMedia('(display-mode: browser)').matches)
                return 'browser';
            if (window.matchMedia('(display-mode: standalone)').matches || navigator.standalone)
                return 'standalone';
            if (window.matchMedia('(display-mode: minimal-ui)').matches)
                return 'minimal-ui';
            if (window.matchMedia('(display-mode: fullscreen)').matches)
                return 'fullscreen';
            if (window.matchMedia('(display-mode: window-controls-overlay)').matches)
                return 'window-controls-overlay';

            return 'unknown';
        },
        getPWADisplayModeOLD() {
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
            console.log('getPWADisplayMode.',isStandalone, window.navigator.standalone,navigator.standalone);
            if (document.referrer.startsWith('android-app://')) {
                return true;
            } else if (navigator.standalone || isStandalone || window.navigator.standalone === true) {
                return true;
            }
            return false;
        },
        async checkInstalledApp() {
            console.log('checkInstalledApp','getInstalledRelatedApps' in window.navigator, await navigator.getInstalledRelatedApps())
            if ('getInstalledRelatedApps' in window.navigator) {
                const relatedApps = await navigator.getInstalledRelatedApps();
                    relatedApps.forEach((app) => {
                        //if your PWA exists in the array it is installed
                        console.log(app.platform, app.url);
                    });
                    console.log('relatedApps',relatedApps);
            }
        } ,
        autoLoginCheckingInterface() {
            // each 100ms we check if the issue was produced
            let intervalDetectAutofill = setInterval(() => {
                if (
                    // we target at least one of the stuff that will be affected by autofill
                    // to do our checking
                    document.querySelectorAll('input[type="email"]:-webkit-autofill').length > 0
                ) {
                    // and we inform the system about the issue if it is produced
                    this.autofillFix = true;

                    // we stop to check if issue was produced
                    clearInterval(intervalDetectAutofill);
                }
            }, 100);

            // if after 3s nothing appear, means no autofill was made
            setTimeout(() => {
                if (intervalDetectAutofill) {
                    clearInterval(intervalDetectAutofill);
                    intervalDetectAutofill = null;
                }
            }, 3000);
        },
        showAutomaticLoginButtons() {
            return window.location.hostname === 'localhost';
        },

        submitForm() {
            if (!this.$refs.form.validate()) return;
            this.loading = true;
            this.form.errors = null;

            axios
                .post('/login', this.form)
                .then(() => {
                    this.userStore.login(this.$inertia, this.$tawkMessenger);
                })
                .catch((error) => {
                    const errors = error.response.data.errors;

                    this.loading = false;
                    this.form.errors = errors;
                });
        },
    },

    layout: AuthLayout,
};
</script>

<style scoped>
.no-underline {
    text-decoration: none;
}

@media only screen and (min-width: 1025px) {
    #inner-auth-content {
        max-width: 350px;
    }
}
</style>

<style>
.autofill-fix.v-text-field.v-input--dense .v-label {
    top: 4px;
    left: 0 !important;
    transform: translateY(-18px) scale(0.75);
}
#install{
    position: fixed;
    top:56px;
    right: 10px;
}
.msg-updating{
     margin-top: 50px;
     margin-bottom: 50px;
     text-align: justify;
}
.link-no-decor {
    text-decoration: none;
}
</style>
